import requestAction from '../utils/requestAction'

export const fetchCurrentPriceList = () =>
  requestAction('CURRENT_PRICE_LIST')('currentPriceList', 'GET')

export const fetchInfoCurrentPriceList = (handleResponse?: (response: any) => void) =>
  requestAction('INFO_CURRENT_PRICE_LIST')('infoCurrentPriceList', 'GET',
undefined,
undefined,
undefined,
(_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })

export const fetchPriceList = (listPriceId: any) =>
  requestAction('INFO_CURRENT_PRICE_LIST')(`infoCurrentPriceList/${listPriceId}`, 'GET')



